const PREFIX = "quick-checkout";

export const QUICK_CHECKOUT_TEST_IDS = {
    HEADER_CTA: `${PREFIX}-header-cta`,
    CONTAINER: `${PREFIX}-container`,
    SHIMMER: `${PREFIX}-cart-shimmer`,
};
